/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Feature2Inputs */

const en_st_mock_feature2 = /** @type {(inputs: St_Mock_Feature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run schedule`)
};

const id_st_mock_feature2 = /** @type {(inputs: St_Mock_Feature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal lari`)
};

/**
* | output |
* | --- |
* | "Run schedule" |
*
* @param {St_Mock_Feature2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_feature2 = /** @type {((inputs?: St_Mock_Feature2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Feature2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_feature2(inputs)
	return en_st_mock_feature2(inputs)
});